import gql from 'graphql-tag';

import { FULL_PLEX_USER_RELATION_FRAGMENT } from '../PlexUserRelation/fullPlexUserRelation';

export const BOARD_OVERVIEW_FRAGMENT = gql`
  fragment boardOverview on Board {
    id
    name
    description
    plexId
    position {
      id
      positionInPlex
    }
    plex {
      id
      name
      currentUserRelation {
        ...fullPlexUserRelation
      }
    }
    source {
      __typename
      ... on GoogleDocumentSource {
        url
      }
    }
  }

  ${FULL_PLEX_USER_RELATION_FRAGMENT}
`;
